export const readErrorResponse = async (response) => {
  const fallbackMessage = `Request failed with status ${response?.status ?? 'unknown'}`;
  const contentType = typeof response?.headers?.get === 'function'
    ? response.headers.get('content-type') || ''
    : '';

  if (contentType.includes('json')) {
    try {
      return await response.json();
    } catch {
      return { error: fallbackMessage };
    }
  }

  try {
    const text = await response.text();
    return { error: text || fallbackMessage };
  } catch {
    return { error: fallbackMessage };
  }
};
